/* SUNDAY BATCH · agent C · D-10 — stored dashboard figures: "As of", "Updating…", Refresh now. EN + AR.
   Registered at the end of lib/i18n.js (one import + two _overrideDeep lines). */
export const I18N_SB_C = {
  en: {
    sbC: {
      asOf: "As of {time}",
      updating: "Updating…",
      updatingAsOf: "Updating… (figures as of {time})",
      updatingNew: "Updating… (figures not calculated yet)",
      updatingCount: "Updating the figures of {n} engagement(s)…",
      refreshNow: "Refresh now",
      refreshing: "Refresh queued — the figures update in the background",
      refreshFailed: "The refresh could not be queued. Try again.",
      refreshTitle: "Recalculate the figures of every engagement now (they also refresh after every change and every night)",
    },
  },
  ar: {
    sbC: {
      asOf: "حتى {time}",
      updating: "جارٍ التحديث…",
      updatingAsOf: "جارٍ التحديث… (الأرقام حتى {time})",
      updatingNew: "جارٍ التحديث… (لم تُحسب الأرقام بعد)",
      updatingCount: "جارٍ تحديث أرقام {n} ارتباط/ارتباطات…",
      refreshNow: "تحديث الآن",
      refreshing: "تم طلب التحديث — تُحدَّث الأرقام في الخلفية",
      refreshFailed: "تعذر طلب التحديث. حاول مرة أخرى.",
      refreshTitle: "إعادة حساب أرقام كل الارتباطات الآن (تُحدَّث أيضًا بعد كل تغيير وكل ليلة)",
    },
  },
};

export default I18N_SB_C;
